module.exports = __webpack_public_path__ + "img/img_carroceria.0bd9353f.webp";